import React from 'react';
import './IntegrationInfoAlert.scss';

const IntegrationInfoAlert = ({ children }) => (
    <div
        className="IntegrationInfoAlert alert alert-info alert-inline mt-0 mb-2 py-2 px-3 small"
        role="alert"
    >
        <span className="alert-inline-body">{children}</span>
    </div>
);

export default IntegrationInfoAlert;
